// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"283":"754783d8222fee49","6458":"bf3b217b7955ee0e"}[chunkId] + ".css";
};